<template>
  <li
    :key="value"
    ref="el"
    @mouseover="emit('over', index)"
    @mouseleave="emit('over', -1)"
    @click="emit('select', index)"
  >
    <span class="form-field-dropbox-option" :data-focus="focused">{{
      name
    }}</span>
  </li>
</template>
<script setup lang="ts">
interface Props {
  value: string;
  name: string;
  index: number;
  focused: boolean;
}
const el = ref(null);
defineProps({
  value: null,
  name: null,
  index: null,
  focused: { type: Boolean }
});
const emit = defineEmits(["over", "select"]);
</script>
<style lang="scss" scoped></style>
